<template>
  <div id="bbquery">
    <el-card class="box-card">
      <div slot="header" class="clearfix newbbtit">
        <span>报备查询&nbsp;/&nbsp;报备管理</span>
        <Xlsx :name="formname"></Xlsx>
      </div>
      <div class="condition">
        <Week @childFn="parentFn"></Week>
        <el-select class="input2" v-model="value2" placeholder="全部报备状态">
          <el-option v-for="item in selet2" :key="item.value" :label="item.label" :value="item.value"/>
        </el-select>
        <el-select class="input3" v-model="value3" placeholder="全部办宴类型">
          <el-option v-for="item in selet3" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-select class="input4" v-model="value4" placeholder="全部采购方式">
          <el-option v-for="item in selet4" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-input class="input5" style="width: 190px" v-model="value5" placeholder="订单号"/>
        <div class="block">
          <el-date-picker
            v-model="screen1"
            value-format="yyyy-MM-dd"
            type="daterange"
            align="right"
            unlink-panels
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="报备开始日期"
            end-placeholder="报备结束日期"
          >
          </el-date-picker>
        </div>
        <div class="block">
          <el-date-picker
            v-model="screen2"
            type="daterange"
            align="right"
            unlink-panels
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="办宴开始日期"
            end-placeholder="办宴结束日期"
          >
          </el-date-picker>
        </div>
        <el-button
          type="primary"
          style="margin-right: 14px"
          @click="query"
          element-loading-text="加载中..."
          element-loading-background="rgba(0, 0, 0, 0.4)"
          v-loading.fullscreen.lock="fullscreenLoading"
        >查询
        </el-button
        >
        <el-button type="info" @click="reset">重置</el-button>
      </div>
      <el-table
        @cell-click="handle"
        id="exportTab"
        stripe
        :data="tableData"
        border
        :sort-method="sortChange1"
        style="width: 100%"
      >
        <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
        <el-table-column prop="createtime" label="报备时间" sortable width="180"></el-table-column>
        <el-table-column label="乡厨" width="120">
          <template slot-scope="scope">
            <p style="color: #11A983; ">{{ scope.row.cookerName }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="cookerPhone" label="厨师手机号" width="120"></el-table-column>
        <el-table-column prop="organizer" label="举办者" width="120"></el-table-column>
        <el-table-column prop="telphone" label="主家手机号" width="120"></el-table-column>
        <el-table-column prop="purchaseModeName" label="采购方式" width="120"></el-table-column>
        <el-table-column prop="purchaser" label="采购人" width="120">
          <template slot-scope="scope">
            {{ scope.row.purchaser === 1?'主家购买':'乡厨购买' }}
          </template>
        </el-table-column>
        <el-table-column prop="orders" label="订单号" min-width="120">
          <template slot-scope="scope">
            <div :title="scope.row && scope.row.orders && scope.row.orders.map(i => i.orderNo).join('\n')">
              <div class="order-no" v-for="(i, index) in (scope.row && scope.row.orders) || []" :key="index">
                {{ i.orderNo }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="办宴时间" width="120">
          <template slot-scope="scope">
            <p>{{ scope.row.dinnertime.substring(0, 10) }}</p>
          </template>
        </el-table-column>
        <el-table-column label="办宴类型" width="120">
          <template slot-scope="scope">
            <p v-if="scope.row.dinnertype == 1" style="color: #ff0000; font-weight: 600;">红事</p>
            <p v-if="scope.row.dinnertype == 2" style="color: #000000; font-weight: 600;">白事</p>
            <p v-if="scope.row.dinnertype == 3" style="color: #ff0000; font-weight: 600;">生日</p>
            <p v-if="scope.row.dinnertype == 4" style="color: #ff0000; font-weight: 600;">状元</p>
            <p v-if="scope.row.dinnertype == 5" style="color: #ff0000; font-weight: 600;">乔迁</p>
            <p v-if="scope.row.dinnertype == 6" style="color: #11A983; font-weight: 600;">其他</p>
          </template>
        </el-table-column>
        <el-table-column label="办宴天数" width="120">
          <template slot-scope="scope">
            <p class="boldfont">{{ scope.row.dinnerdays }}</p>
          </template>
        </el-table-column>
        <el-table-column label="办宴桌数" width="120">
          <template slot-scope="scope">
            <p class="boldfont">{{ scope.row.dinnerDesk }}</p>
          </template>
        </el-table-column>
        <el-table-column label="参宴人数" width="120">
          <template slot-scope="scope">
            <p class="boldfont">{{ scope.row.dinnerDiners }}</p>
          </template>
        </el-table-column>
        <el-table-column label="燃料类型" width="160">
          <template slot-scope="scope">
            <p v-if="scope.row.fuelType == null || scope.row.fuelType == ''">无</p>
            <p v-else>{{ scope.row.fuelType }}</p>
          </template>
        </el-table-column>
        <el-table-column label="办宴备注" width="200">
          <template slot-scope="scope">
            <p v-if="scope.row.dinnerRemarks == null || scope.row.dinnerRemarks == ''">无</p>
            <p v-else>{{ scope.row.dinnerRemarks }}</p>
          </template>
        </el-table-column>
        <el-table-column min-width="260" label="举办地址">
          <template slot-scope="scope">
            <p>
              {{ scope.row.city }} {{ scope.row.district }}
              {{ scope.row.town }} {{ scope.row.village }}
              {{ scope.row.address }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="报备状态" width="120">
          <template slot-scope="scope">
            <p class="boldfont" v-if="scope.row.reportedstate == 1" style="color: #efa02a">待审核</p>
            <p class="boldfont" v-if="scope.row.reportedstate == 2" style="color: #f56c6c">被驳回</p>
            <p class="boldfont" v-if="scope.row.reportedstate == 3" style="color: #11A983">待检查</p>
            <p class="boldfont" v-if="scope.row.reportedstate == 4" style="color: #11A983">初查通过</p>
            <p class="boldfont" v-if="scope.row.reportedstate == 5" style="color: #f56c6c">检查不通过</p>
            <p class="boldfont" v-if="scope.row.reportedstate == 6" style="color: #f56c6c">过期未检查</p>
            <p class="boldfont" v-if="scope.row.reportedstate == 7" style="color: #67c23a">检查合格</p>
            <p class="boldfont" v-if="scope.row.reportedstate == 8" style="color: #f56c6c">检查不合格</p>
            <p class="boldfont" v-if="scope.row.reportedstate == 9" style="color: #f56c6c">过期未复查</p>
            <p class="boldfont" v-if="scope.row.reportedstate == 10" style="color: #f56c6c">过期未审核</p>
            <p class="boldfont" v-if="scope.row.reportedstate == 11" style="color: #11A983">乡厨待接受</p>
            <p class="boldfont" v-if="scope.row.reportedstate == 12" style="color: #f56c6c">乡厨已驳回</p>
            <p class="boldfont" v-if="scope.row.reportedstate == 13" style="color: #11A983">食材待审核</p>
          </template>
        </el-table-column>
        <el-table-column prop="xgInfo.username" label="协管员" width="120">
        </el-table-column>
        <el-table-column prop="xgInfo.telMobile" label="手机号" width="120">
        </el-table-column>
        <el-table-column prop="sabInfo.username" label="食安办" width="120">
        </el-table-column>
        <el-table-column prop="sabInfo.telMobile" label="手机号" width="120">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="360">
          <template slot-scope="scope">
            <!--<el-button size="mini" type="primary" @click="foot(scope.row, 'reportQuery:delete')">-->
            <!--  <i class="el-icon-truck"></i> 溯源信息-->
            <!--</el-button>-->
            <el-button size="mini" type="primary" @click="$router.push({name: 'bbqueryProduct', query: {id: scope.row.rid}})">
              溯源信息
            </el-button>
            <el-button size="mini" type="success" @click="handleEdit(scope.row)">
              详情
            </el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row, 'reportQuery:delete')">
              删除
            </el-button>
            <el-button size="mini" type="primary" @click="handleRouterTrack(scope.row)" style="background-color: #409eff; border-color: #409eff">
              物流轨迹
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging">
        <span
        >共 <i class="pagingNum">{{ total }}</i> 条</span
        >
        <Paging :gopage="total" @pag="pag"></Paging>
      </div>
    </el-card>
    <el-dialog title="报备管理 / 详情" :visible.sync="dialogFormVisible" width="60%" class="myxx">
      <div class="ncont">
        <div>
          <h5>厨师信息</h5>
          <div class="content">
            <p>
              <span>厨师：{{ details.cookName }}</span>
              <span>帮厨人数（{{ peopnum }}人） :
                <i v-for="(item, index) in details.helperInfos" :key="index" style="margin-right: 10px">
                  {{ item.helperName }}
                </i>
              </span>
            </p>
            <p>
              <span>联系电话 : {{ details.cookPhone }}</span>
            </p>
          </div>
        </div>
        <div>
          <h5>办宴信息</h5>
          <div class="content">
            <p>
              <span>办宴地址 : {{ details.dinnerAddress }}</span>
              <span
              >办宴类型 :
                <i v-if="details.dinnerType == 1">红事</i>
                <i v-if="details.dinnerType == 2">白事</i>
                <i v-if="details.dinnerType == 3">生日</i>
                <i v-if="details.dinnerType == 4">状元</i>
                <i v-if="details.dinnerType == 5">乔迁</i>
                <i v-if="details.dinnerType == 6">其他</i>
              </span>
              <span>办宴桌数 : {{ details.dinnerDesk }}</span>
              <span>办宴备注 :
                <i v-if="details.dinnerRemarks == null || details.dinnerRemarks == ''">无</i>
                <i v-else>{{ details.dinnerRemarks }}</i></span>
            </p>
            <p>
              <span>办宴时间 : {{ details.dinnerTime }}</span>
              <span>办宴天数 : {{ details.dinnerDays }}</span>
              <span>参宴人数 : {{ details.dinnerDiners }}</span>
              <span>燃料类型 : <i v-if="details.fuelType == null || details.fuelType == ''">无</i>
                <i v-else>{{ details.fuelType }}</i></span>
            </p>
          </div>
        </div>
        <div>
          <h5>加工场地信息</h5>
          <div class="content">
            <p>
              <span>
                使用水源 :
                <i v-if="details.waterType == 1">自备水源</i>
                <i v-if="details.waterType == 2">城市管网水</i>
              </span>
              <span>
                留样设施 :
                <i v-if="details.isReserved == 1">有</i>
                <i v-if="details.isReserved == 2">无</i>
              </span>
              <span>餐具保洁柜数量 : {{ details.cleanBoxs }}</span>
              <span>专用消毒柜数量 : {{ details.sterilizeBoxs }}</span>
              <span>带盖垃圾桶数量 : {{ details.dustbins }}</span>
            </p>
            <p>
              <span>餐具消毒方式 :
                <i v-if="details.sterilizeType == 1">消毒柜</i>
                <i v-if="details.sterilizeType == 2">沸水</i>
                <i v-if="details.sterilizeType == 3">药物</i>
                <i v-if="details.sterilizeType == 4">其他</i>
              </span>
              <span>有无贮存或使用有毒有害物品 :
                <i v-if="details.isHarmful == 1">有</i>
                <i v-if="details.isHarmful == 2">无</i>
              </span>
              <span>冰箱数量 : {{ details.refrigerators }}</span>
              <span>食品留样柜数量 : {{ details.reservedNum }}</span>
              <span>防鼠、防蝇、防尘设施数量 : {{ details.shieldNum }}</span>
            </p>
          </div>
        </div>
        <div>
          <h5>检查信息</h5>
          <div class="content">
            <p>
              <span style="font-weight: 600">协管员</span>
              <span>姓名 : {{ xgInfodata.username }}</span>
              <span>性别 : {{ xgInfodata.userSex }}</span>
              <span>电话 : {{ xgInfodata.telMobile }}</span>
              <span>地区 : {{ xgInfodata.city }} {{ xgInfodata.district }}
                {{ xgInfodata.town }} {{ xgInfodata.village }}
              </span>
            </p>
            <p>
              <span style="font-weight: 600">食安办</span>
              <span>姓名 : {{ sabInfodata.username }}</span>
              <span>性别 : {{ sabInfodata.userSex }}</span>
              <span>电话 : {{ sabInfodata.telMobile}}</span>
              <span
              >地区 : {{ sabInfodata.city }} {{ sabInfodata.district }}
                {{ sabInfodata.town }} {{ sabInfodata.village }}</span
              >
            </p>
          </div>
        </div>
        <div>
          <h5>检查情况</h5>
          <div class="content">
            <p>
              <span>检查时间 : {{ inspect.checkTime }}</span>
              <span>帮厨卫生 :
                <i v-if="inspect.helperHygiene == 1">合格</i>
                <i v-if="inspect.helperHygiene == 0">不合格</i>
              </span>
              <span>加工场地远离污染源 :
                <i v-if="inspect.factorySafe == 1">合格</i>
                <i v-if="inspect.factorySafe == 0">不合格</i>
              </span>
              <span>消毒要求 :
                <i v-if="inspect.sterilizeSafe == 1">合格</i>
                <i v-if="inspect.sterilizeSafe == 0">不合格</i>
              </span>
              <span>食材要求 :
                <i v-if="inspect.foodSafe == 1">合格</i>
                <i v-if="inspect.foodSafe == 0">不合格</i>
              </span>
              <span>有害物质检测 :
                <i v-if="inspect.harmfulSafe == 1">合格</i>
                <i v-if="inspect.harmfulSafe == 0">不合格</i>
              </span>
              <span>风险点 : {{ inspect.riskPoint }}</span>
            </p>
            <p>
              <span>主厨卫生 :
                <i v-if="inspect.chefHygiene == 1">合格</i>
                <i v-if="inspect.chefHygiene == 0">不合格</i>
              </span>
              <span>场地所离污染源 :
                <i v-if="inspect.placeSafe == 1">合格</i>
                <i v-if="inspect.placeSafe == 0">不合格</i>
              </span>
              <span>储存地要求 :
                <i v-if="inspect.storageSafe == 1">合格</i>
                <i v-if="inspect.storageSafe == 0">不合格</i>
              </span>
              <span>饮水要求 :
                <i v-if="inspect.waterSafe == 1">合格</i>
                <i v-if="inspect.waterSafe == 0">不合格</i>
              </span>
              <span>食材发票 :
                <i v-if="inspect.foodInvoice == 1">合格</i>
                <i v-if="inspect.foodInvoice == 0">不合格</i>
              </span>
              <span>留样要求 :
                <i v-if="inspect.reservedSafe == 1">合格</i>
                <i v-if="inspect.reservedSafe == 0">不合格</i>
              </span>
              <span>风险点整改情况 : {{ inspect.riskMend }}</span>
            </p>
          </div>
        </div>
        <div>
          <h5>现场照片</h5>
          <div class="content" v-if="inspect.localePhoto != null">
            <viewer>
              <img
                class="contimg"
                v-for="(item, index) in inspect.localePhoto"
                :key="index"
                :src="imgUrl + item"
                alt=""
              />
            </viewer>
          </div>
          <div class="content" v-else>暂无</div>
        </div>
        <div>
          <h5>主家签字</h5>
          <div class="content" v-if="inspect.signPhone != null">
            <viewer>
              <img
                class="contimg"
                v-for="(item, index) in inspect.signPhone"
                :key="index"
                :src="imgUrl + item"
                alt=""
              />
            </viewer>
          </div>
          <div class="content" v-else>暂无</div>
        </div>
        <div>
          <h5>综合评分</h5>
          <div class="content"></div>
        </div>
        <div>
          <h5>溯源信息</h5>
          <div class="content"></div>
        </div>
      </div>
      <div style="width: 26%">
        <h5>审核状态</h5>
        <p style="font-size: 32px; color: #11A983; font-weight: 600">
          <span v-if="details.reportedState == 1" style="color: #efa02a">待审核</span>
          <span v-if="details.reportedState == 2" style="color: #f56c6c">被驳回</span>
          <span v-if="details.reportedState == 3" style="color: #efa02a">待检查</span>
          <span v-if="details.reportedState == 4" style="color: #efa02a">初查通过</span>
          <span v-if="details.reportedState == 5" style="color: #f56c6c">检查不通过</span>
          <span v-if="details.reportedState == 6" style="color: #f56c6c">过期未检查</span>
          <span v-if="details.reportedState == 7" style="color: #67c23a">检查合格</span>
          <span v-if="details.reportedState == 8" style="color: #f56c6c">检查不合格</span>
          <span v-if="details.reportedState == 9" style="color: #efa02a">过期未复查</span>
          <span v-if="details.reportedState == 10" style="color: #efa02a">过期未审核</span>
          <span v-if="details.reportedState == 11" style="color: #efa02a">乡厨待接受</span>
          <span v-if="details.reportedState == 12" style="color: #f56c6c">乡厨已驳回</span>
          <span v-if="details.reportedState == 13" style="color: #efa02a">食材待审核</span>
        </p>
      </div>
    </el-dialog>
    <el-dialog
      title="协管员/食安办信息"
      :visible.sync="xgdet"
      width="60%"
      class="myxx newdata shian"
    >
      <div>
        <span style="font-weight: 600; font-size: 18px">协管员：</span>
        <span>姓名：{{ xgdata.xgInfo.username }}</span>
        <span>性别：{{ xgdata.xgInfo.userSex }}</span>
        <span>号码：{{ xgdata.xgInfo.telMobile }}</span>
        <span>地区：{{ xgdata.xgInfo.city }} {{ xgdata.xgInfo.district }}
          {{ xgdata.xgInfo.town }} {{ xgdata.xgInfo.village }}
        </span>
        <span style="font-weight: 600; font-size: 18px; margin-top: 24px">食安办：</span>
        <span>姓名：{{ xgdata.sabInfo.username }}</span>
        <span>性别：{{ xgdata.sabInfo.userSex }}</span>
        <span>号码：{{ xgdata.sabInfo.telMobile }}</span>
        <span>地区：{{ xgdata.sabInfo.city }} {{ xgdata.sabInfo.district }}
          {{ xgdata.sabInfo.town }} {{ xgdata.sabInfo.village }}
        </span>
      </div>
    </el-dialog>
    <el-dialog title="溯源信息" :visible.sync="scdet" width="60%" class="myxx">
      <el-table
        stripe
        :data="tableData2"
        border
        :sort-method="sortChange1"
        style="width: 100%"
      >
        <!-- <el-table-column type="selection" width="60"></el-table-column> -->
        <!-- <el-table-column prop="id" label="序号" width="80"></el-table-column> -->
        <el-table-column prop="name" label="名称" width="120"></el-table-column>
        <el-table-column prop="num" label="数量" width="120"></el-table-column>
        <el-table-column prop="place" label="产地" width="120"></el-table-column>
        <el-table-column prop="supplierName" label="供应商" width="160"></el-table-column>
        <el-table-column prop="manufacturer" label="生产厂家" width="160"></el-table-column>
        <el-table-column prop="productionTime" label="生产日期" width="160"></el-table-column>
        <el-table-column prop="days" label="保质期（天）" width="160"></el-table-column>
        <el-table-column prop="buyerName" label="采购员" width="160"></el-table-column>
        <el-table-column prop="warehouseTime" label="入库时间" width="160"></el-table-column>
        <el-table-column prop="addTime" label="添加时间" width="160"></el-table-column>
        <el-table-column prop="updateTime" label="修改时间" width="160"></el-table-column>
        <el-table-column label="是否上架" sortable width="160">
          <template slot-scope="scope">
            <p class="boldfont" v-if="scope.row.isOnSale == 1" style="color: #67c23a">是</p>
            <p class="boldfont" v-else style="color: #f56c6c">否</p>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <router-track-dialog ref="routerTrackDialog" />
  </div>
</template>
<script>
import Week from "@/components/Week";
import Xlsx from "@/components/Xlsx";
import Paging from "@/components/Paging";
import RouterTrackDialog from "@/components/router-track/index.vue";

export default {
  name: "bbquery",
  components: {
    RouterTrackDialog,
    Week,
    Xlsx,
    Paging,
  },
  data() {
    return {
      selet2: [
        {value: "0", label: "全部报备状态"},
        {value: "1", label: "待审核"},
        {value: "2", label: "被驳回"},
        {value: "3", label: "待检查"},
        {value: "4", label: "初查通过"},
        {value: "5", label: "检查不通过"},
        {value: "6", label: "过期未检查"},
        {value: "7", label: "复查通过（检查合格）"},
        {value: "8", label: "复查未通过（检查不合格）"},
        {value: "9", label: "过期未复查"},
        {value: "10", label: "过期未审核"},
        {value: "11", label: "乡厨待接受"},
        {value: "12", label: "乡厨已驳回"}
      ],
      value2: "",
      selet3: [
        {value: "0", label: "全部办宴类型"},
        {value: "1", label: "红事"},
        {value: "2", label: "白事"},
        {value: "3", label: "生日"},
        {value: "4", label: "状元"},
        {value: "5", label: "乔迁"},
        {value: "6", label: "其他"},
      ],
      value3: "",
      selet4: [
        {value: null, label: "全部采购方式"},
        {value: 1, label: "平台+自主"},
        {value: 2, label: "平台"},
        {value: 3, label: "自主"},
      ],
      value4: "",
      value5: "",
      screen1: "",
      screen2: "",
      tableData: [],
      userdata: {},
      pageNum: 1,
      pageSize: 10,
      dialogFormVisible: false,
      details: {},
      peopnum: "",
      inspect: {}, //检查情况
      areaId: "",
      total: 0,
      formname: JSON.stringify({name: "报备查询表", hint: ""}),
      fullscreenLoading: true,
      imgUrl: this.$Public.imgUrl,
      xgdet: false,
      scdet: false,
      xgdata: {xgInfo: {}, sabInfo: {}},
      xgInfodata: {},
      sabInfodata: {},
      tableData2: [],
      btn: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  created() {
    this.load();
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
  },
  computed: {
    data() {
      return this.tableData;
    },
  },
  methods: {
    // 食材溯源
    foot(x, hint) {
      if (this.btn.indexOf(hint) == -1) {
        return this.$message("抱歉，用户暂无该权限");
      }
      this.scdet = true;
    },
    handle(row, column) {
      if (
        column.property == "xgInfo.username" ||
        column.property == "sabInfo.username"
      ) {
        if (row.xgInfo != null || row.sabInfo != null) {
          this.xgdet = true;
          this.xgdata = row;
        }
      }
      if (row.xgInfo != null) {
        this.xgInfodata = row.xgInfo;
      } else {
        this.xgInfodata = {};
      }
      if (row.sabInfo != null) {
        this.sabInfodata = row.sabInfo;
      } else {
        this.sabInfodata = {};
      }
    },
    // 分页数据加载
    pag(val) {
      this.pageNum = val.pageNum;
      this.pageSize = val.pageSize;
      this.fullscreenLoading = true;
      this.load();
    },
    parentFn(i) {
      this.areaId = i.id;
    },
    load() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        adminAreasId: userdata.areasId,
        areaId: this.areaId,
        dinnerStartTime: this.screen2 == null ? "" : this.screen2[0], //办宴开始时间
        dinnerEndTime: this.screen2 == null ? "" : this.screen2[1], //办宴结束时间
        reoportStartTime: this.screen1 == null ? "" : this.screen1[0], //报备开始时间
        reoportEndTime: this.screen1 == null ? "" : this.screen1[1], //报备结束时间
        reportedstate: this.value2,
        reportedtype: this.value3,
        purchaseMode: this.value4,
        orderNo: this.value5,
      });
      this.$axios
        .post(`/api-r/report/getReportList`, data, {
          headers: {accessToken: userdata.token},
        })
        .then((res) => {
          // console.log(res,'报备列表')
          if (res.data.success) {
            this.fullscreenLoading = false;
            this.$set(this, "total", res.data.pageInfo.total);
            this.$set(this, "tableData", res.data.pageInfo.list);
            this.$message({
              type: "success",
              message: res.data.msg,
            });
          } else {
            this.$message(res.data.msg);
          }
        });
    },
    query() {
      this.pageNum = 1;
      this.fullscreenLoading = true;
      this.load();
    },
    reset() {
      this.$router.push("/refresh");
    },
    handleEdit(row) {
      // this.dialogFormVisible = true
      this.$axios
        .post(
          `/api-r/report/getReportInfo/${row.rid}`,
          {},
          {headers: {accessToken: this.userdata.token}}
        )
        .then((res) => {
          // console.log(res)
          if (res.data.success == true) {
            if (res.data.checkInfo.localePhoto != null) {
              res.data.checkInfo.localePhoto = res.data.checkInfo.localePhoto.split(
                ","
              );
            }
            if (res.data.checkInfo.signPhone != null) {
              res.data.checkInfo.signPhone = res.data.checkInfo.signPhone.split(
                ","
              );
            }
            res.data.dinnerTime = this.$Public.date(res.data.dinnerTime / 1000);
            this.$set(this, "details", res.data);
            this.$set(this, "peopnum", res.data.helperInfos.length);
            this.$set(this, "inspect", res.data.checkInfo);
            this.dialogFormVisible = true;
          }
        });
    },
    handleDelete(index, hint) {
      if (this.btn.indexOf(hint) == -1) {
        return this.$message("抱歉，用户暂无该权限");
      }
      this.$confirm("此操作将删除该报备, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(
              `/api-r/report/deleteReport/${index.rid}`,
              {},
              {headers: {accessToken: this.userdata.token}}
            )
            .then((res) => {
              if (res.data.success) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.load();
              } else {
                this.$message(res.data.msg);
              }
            });
        })
        .catch(() => {
        });
    },
    sortChange1(a, b) {
      console.log(a, b);
    },
    handleRouterTrack(row) {
      this.$refs.routerTrackDialog.open({
        orders: row.orders
      })
    }
  },
};
</script>
<style scoped>
.order-no {
  height: 16px;
  line-height: 14px;
  padding: 0 4px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: 'Helvetica Neue', sans-serif;
}
</style>
<style>
/* #bbquery .el-pagination .el-input{width: 120px} */
#bbquery .el-table td,
.el-table th.is-leaf {
  text-align: center;
}

/* #bbquery .el-pagination{padding: 24px;float: right;} */
#bbquery .el-dialog {
  width: 930px;
}

#bbquery .newdata .el-dialog {
  width: 633px;
}

#bbquery .el-dialog__body {
  display: flex;
  justify-content: space-between;
}

#bbquery .el-pagination__sizes .el-select {
  margin-top: -12px;
}

#bbquery .el-input__inner {
  margin: 10px 0;
}

#bbquery .shian .el-dialog__body {
  height: 100%;
}

#bbquery .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
</style>
<style scoped lang="scss">
$bba: #11A983;
.condition {
  display: flex;
  flex-flow: wrap;
  margin-bottom: 20px;
  align-items: center;
}

.input1,
.input2,
.input3,
.input4,
.input5,
.block {
  margin: 0 16px 0 0;
}

.query {
  font-size: 23px;
  background-color: #11A983;
  color: #fff;
  width: 78px;
  line-height: 38px;
  display: inline-block;
  text-align: center;
}

.reset {
  font-size: 23px;
  background-color: #ccc;
  color: #fff;
  width: 78px;
  line-height: 38px;
  text-align: center;
}

h5 {
  color: $bba;
  margin: 20px 0;
  font-size: 16px;
}

.ncont {
  width: 72%;
}

.content {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 16px;
  position: relative;

  & > p > span {
    display: block;
    margin-bottom: 14px;
    width: 305px;
  }

  & > p:nth-of-type(2) {
    width: 44%;
  }
}

.newbbtit {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.contimg {
  width: 200px;
  margin-right: 20px;
}

.newdata div > span {
  display: block;
  line-height: 30px;
}
</style>
